var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "index" }, [
      _c("div", { staticClass: "banner" }),
      _vm._v(" "),
      _c("section", { staticClass: "content about-us" }, [
        _c("div", { staticClass: "content-wrap" }, [
          _c("h2", { staticClass: "content-title" }, [_vm._v("会社概要")]),
          _vm._v(" "),
          _c("div", { staticClass: "detail b2" }, [
            _c("p", [_vm._v("インスタキャッシュ株式会社")]),
            _vm._v(" "),
            _c("p", [_vm._v("〒150-0002 東京都渋谷区渋谷1丁目3番9号 624")]),
            _vm._v(" "),
            _c("p", [_vm._v("代表取締役 湯浅健一(予定)")]),
            _vm._v(" "),
            _c("p", [_vm._v("資本金 9,000万円")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-wrap" }, [
          _c("h2", { staticClass: "content-title" }, [_vm._v("沿革")]),
          _vm._v(" "),
          _c("div", { staticClass: "detail b2" }, [
            _c("p", [_vm._v("2017年8月22日 設立")]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-wrap" }, [
          _c("h2", { staticClass: "content-title" }, [_vm._v("ニュース")]),
          _vm._v(" "),
          _c("div", { staticClass: "detail b2" }, [
            _c("p", [_vm._v("新規ビジネス開始に向け準備中")]),
          ]),
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "mission-pic",
          attrs: { src: require("./img/mission-pic.jpg") },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }